(function ($) {
  function UIElements() {
    this.config = {
      $tooltip: $('.question-tooltip'),
    };

    this.init();
  }

  UIElements.prototype.tooltip = function () {
    var self = this;
    if (!self.config.$tooltip.length) return false;

    function getClassNameOnCalcOffsets(tooltip) {
      var tooltipBoundingClientRect = $(tooltip)[0].getBoundingClientRect();
      var leftOffset = tooltipBoundingClientRect.left - 200;

      return leftOffset > 0 ? 'left' : 'right';
    }

    function processTooltipPositions() {
      self.config.$tooltip.each(function () {
        var $tooltip = $(this);
        $tooltip.removeClass('left right').addClass(getClassNameOnCalcOffsets($tooltip));
      });
    }

    processTooltipPositions.bind(self);
    processTooltipPositions();

    $(window).resize(processTooltipPositions);
  };

  UIElements.prototype.init = function () {
    this.tooltip();
  };

  $(document).ready(function () {
    var uiElements = new UIElements();
  });
})(jQuery);
